<script>
const CountryListAPI = "https://ams4you.net/amsapi/public/websearch/GetAcaCountryList";
const CountryChangeAPI = "https://ams4you.net/amsapi/public/websearch/GetAcaCountryChange";
import axios from "axios";
export default {
    data() {
        return {
            query: "",
            SelCountry: {},
            SelLevel: [],
            Keyword: "",
            LevelLabel: "",
            CountryList: [],
            LevelList: [],
            LevelMenu: false,
        };
    },
    computed: {
        Setting() {
            return this.$parent.Setting;
        },
        Translation() {
            return this.$parent.Translation;
        },
    },
    watch: {
        SelCountry(val) {
            this.SelLevel = [];
            this.LevelList = [];
            if (val?.Id) {
                let LatestQuery = this.query + "&CountryId=" + val.Id;
                this.GetLevels(LatestQuery);
            }
        },
        SelLevel: {
            handler(val) {
                if (val.length) {
                    if (val?.length == 1) {
                        let first = val[0].Name;
                        first = val[0].Name?.length > 14 ? val[0].Name.slice(0, 14) + "..." : val[0].Name;
                        this.LevelLabel = first;
                    } else if (val?.length > 1 && val?.length < this.LevelList?.length) {
                        let first = val[0].Name;
                        first = val[0].Name?.length > 14 ? val[0].Name.slice(0, 14) + "..." : val[0].Name;
                        this.LevelLabel = first + `(+${val.length - 1} More)`;
                    } else if (val?.length == this.LevelList?.length) {
                        this.LevelLabel = "All Levels";
                    } else {
                        this.LevelLabel = "Select Academic Level";
                    }
                } else {
                    this.LevelLabel = "Select Academic Level";
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        MakeSearch() {
            let Path = "https://my.alternatifecs.com/search/academic";
            let SelLevelIds = this.SelLevel.map((el) => el.Id).join("-");
            let query = "?CountryId=" + this.SelCountry.Id + "&LevelId=" + SelLevelIds + "&Keyword=" + this.Keyword;
            window.open(Path + query, this.Setting.OpenInNewWindow ? "_blank" : "_self");
        },
        async GetCountries() {
            let ag = this.$parent.ag;
            let wid = this.$parent.wid;
            this.query = "?ag=" + ag + "&wfid=" + wid;
            const request = await axios.get(CountryListAPI + this.query);
            const response = request.data;
            this.CountryList = response.detail;
        },
        async GetLevels(query) {
            const request = await axios.get(CountryChangeAPI + query);
            const response = request.data;
            this.LevelList = response.detail;
        },
    },
    mounted() {
        this.GetCountries();
    },
};
</script>
<template>
    <div class="widget">
        <div class="widget-content">
            <div class="form-row">
                <v-select
                    class="form-control"
                    :options="CountryList"
                    label="Name"
                    :getOptionLabel="(option) => option.Name || 'Select Country'"
                    :clearable="false"
                    v-model="SelCountry"
                    :placeholder="'Select Country'"
                />
            </div>
            <div class="form-row" v-if="SelCountry?.Id">
                <div class="dropdown w-100 pe-4" id="VDropCnt">
                    <button
                        type="button"
                        :class="{show: LevelMenu, 'pe-none': !SelCountry?.Id}"
                        @click="LevelMenu = !LevelMenu"
                        class="btn btn-input btn-dropdown dropdown-dark text-start"
                        id="VDropBtn"
                    >
                        <span class="btn-input-selected text-dark" id="VDropLbl" :class="{'pe-none': !SelCountry?.Id}">{{ LevelLabel }}</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-animate dropdown-menu-list w-100" :class="{show: LevelMenu}" id="VDrop">
                        <button type="button" class="btn btn-dropdown-close" data-bs-toggle="dropdown" aria-expanded="false" @click="LevelMenu = !LevelMenu">
                            <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="m4.21 4.387.083-.094a1 1 0 0 1 1.32-.083l.094.083L12 10.585l6.293-6.292a1 1 0 1 1 1.414 1.414L13.415 12l6.292 6.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083L12 13.415l-6.293 6.292a1 1 0 0 1-1.414-1.414L10.585 12 4.293 5.707a1 1 0 0 1-.083-1.32l.083-.094-.083.094Z"
                                    fill="#333"
                                />
                            </svg>
                        </button>
                        <div class="dropdown-close-list">
                            <li v-for="(item, index) in LevelList" :key="item.Id" class="filter-checkbox-list-item form-check">
                                <input class="form-check-input" type="checkbox" :id="'lvl_' + item.Id" :value="{Name: item.Name, Id: item.Id}" v-model="SelLevel" />
                                <label class="form-check-label" :for="'lvl_' + item.Id">{{ item.Name }} ({{ item.progCount }})</label>
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
            <div class="form-row" v-if="SelCountry?.Id && SelLevel?.length">
                <input id="searchboxText" type="text" class="form-control" placeholder="Program Name (Type English)" v-model="Keyword" />
            </div>
        </div>
        <div class="widget-footer">
            <button type="submit" class="btn fw-500 px-4 text-center flex-grow-1" :disabled="!SelLevel?.length" @click="MakeSearch()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search me-1 fs-9" viewBox="0 0 16 16">
                    <path
                        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                    />
                </svg>
                Search
            </button>
        </div>
    </div>
</template>
